import axios from 'axios';

class ChangePasswordService {
  changePassword(password, passwordResetHash) {
    return axios.post('/api/auth/ResetPasswordWithToken', {
      NewPassword: password,
      Token: passwordResetHash,
    });
  }
}

export default new ChangePasswordService();
